<template></template>

<script>
    export default {
        props: ["order", "products", "discount"],
        data() {
            return {};
        },
        created() {
            if (!this.getCookie(this.order.reference)) {
                let temp_cart = [];

                this.products.forEach((o) => {
                    let json = JSON.parse(o.pivot.combination);
                    let entry = {};

                    if (typeof json.gaId != "undefined") {
                        entry.id = json.gaId;
                    } else {
                        entry.id = o.pivot.product_id;
                    }

                    entry.quantity = o.pivot.quantity;
                    temp_cart.push(entry);
                });

                fbq("track", "Purchase", {
                    value: parseFloat(this.order.final_price),
                    currency: "EUR",
                    contents: temp_cart,
                    content_type: "product_group",
                    content_name: this.order.reference,
                });

                let products_gtm = [];

                let discount_code = "";

                if (this.discount != null) {
                    discount_code = this.discount.code;
                }

                this.products.forEach((o) => {
                    let json = JSON.parse(o.pivot.combination);

                    let entry = {};

                    if (typeof json.gaId != "undefined") {
                        entry.item_id = json.gaId;
                    } else {
                        entry.item_id = o.pivot.product_id;
                    }

                    entry.quantity = o.pivot.quantity;
                    entry.item_brand = "Cantina Roeno";
                    entry.item_name = o.name.replace("<br>", " ");
                    entry.item_price = String(json.price).replace(",", ".");
                    entry.item_variant = json.combination;
                    entry.item_category = json.type;
                    entry.coupon = discount_code;
                    products_gtm.push(entry);
                });

                dataLayer.push({ ecommerce: null }); // Clear the previous ecommerce object.
                dataLayer.push({
                    event: "purchase",
                    ecommerce: {
                        transaction_id: this.order.reference,
                        affiliation: "",
                        value: this.$root.currencyDisplayGtm(this.order.final_price),
                        currency: "EUR",
                        tax: parseFloat((this.order.total_price * this.order.tax_rate) / 100) + parseFloat(this.order.duties_price),
                        shipping: this.order.shipment_price,
                        items: products_gtm,
                    },
                });

                this.setCookie(this.order.reference, "1", "30");
            }
        },
        mounted() {},
        methods: {
            setCookie(key, value, expiry) {
                let expires = new Date();
                expires.setTime(expires.getTime() + expiry * 24 * 60 * 60 * 1000);
                document.cookie = key + "=" + value + ";expires=" + expires.toUTCString();
            },
            getCookie(key) {
                let keyValue = document.cookie.match("(^|;) ?" + key + "=([^;]*)(;|$)");
                return keyValue ? keyValue[2] : null;
            },
        },
        beforeDestroy() {},
    };
</script>
